import React from 'react';
import { isEmpty } from 'lodash';

interface ServicePortsCellProps {
    destinationPortsData: string | string[];
    sourcePortsData: string |string[];
}

export const ServicePortsCell: React.FC<ServicePortsCellProps> = ({ destinationPortsData, sourcePortsData }) => {

    const setPort = (ports: any): string => {
        if (Array.isArray(ports) && !isEmpty(ports)) {
            return ports.join(', ');
        }return ports;
    };
    return <div className={'service-ports-cell'}>
        {sourcePortsData?.length > 0 && <div className={'direction'}>Source: <p>{setPort(sourcePortsData)}</p>
        </div>}
        {destinationPortsData?.length > 0 && <div className={'direction'}>Destination: <p>{setPort(destinationPortsData)}</p>
        </div>}
    </div>;
};
